// import React from 'react';
// import { Outlet } from 'react-router-dom';
// import Sidebar from '../components/Sidebar';

// const DashboardPage = () => {
//   const role = localStorage.getItem('role');
//   return (
//     <div className="flex min-h-screen bg-gray-100">
//       <Sidebar role={role} />
//       <div className="flex-1 ml-64 p-6 overflow-y-auto">
//         <Outlet />
//       </div>
//     </div>
//   );
// };

// export default DashboardPage;
import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';

const DashboardPage = () => {
  const role = localStorage.getItem('role');
  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar role={role} />
      {/* On mobile: add top padding for the fixed top bar (h-16). On desktop: add left margin for sidebar (w-64) */}
      <div className="flex-1 pt-16 lg:pt-0 lg:ml-64 p-4 sm:p-6 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardPage;